(function() {
  setTimeout(()=>{

        var productId = window.hulkapps && window.hulkapps.product ? window.hulkapps.product.id : null;

        const validProductIds = [
            9559614980343, 9559623532791, 9559615176951, 9559615471863, 
            9559615439095, 9559615308023, 9559615275255, 9559615242487, 
            9559615144183, 9559615045879
        ];
        
        if (!validProductIds.includes(productId)) {
    
            console.log("Swatch Debug: Product ID " + productId + " matched. Executing swatch functionality.");
          
            var lastActiveSwatch = null;
            var lastActiveHidden = null;
          
            function enforceUniqueSwatch() {
              var activeSwatches = document.querySelectorAll('.hulk_po_radio.swatch_selected');
              activeSwatches.forEach(function(swatch) {
                if (swatch !== lastActiveSwatch) {
                  swatch.classList.remove('swatch_selected');
                }
              });
            }
          
            function enforceUniqueHidden() {
              var allHidden = document.querySelectorAll('.hulk_swatch_hidden_prop');
              allHidden.forEach(function(input) {
                if (input !== lastActiveHidden && input.value.trim() !== "") {
                  input.value = "";
                }
              });
            }
          
            var swatchObserver = new MutationObserver(function(mutationsList) {
              enforceUniqueSwatch();
            });
            document.querySelectorAll('.hulk_po_radio').forEach(function(node) {
              swatchObserver.observe(node, { attributes: true, attributeFilter: ['class'] });
            });
          
            var hiddenObserver = new MutationObserver(function(mutationsList) {
              enforceUniqueHidden();
            });
            document.querySelectorAll('.hulk_swatch_hidden_prop').forEach(function(node) {
              hiddenObserver.observe(node, { attributes: true, attributeFilter: ['value'] });
            });
          
            function initSwatchSelector() {
              var swatches = document.querySelectorAll('.hulk_po_radio');
              console.log("Swatch Debug: Found " + swatches.length + " swatches.");
          
              swatches.forEach(function(swatch) {
                swatch.addEventListener('click', function(e) {
                  e.preventDefault();
                  var optionContainer = swatch.closest('.hulkapps_option');
                  if (swatch.classList.contains('swatch_selected')) {
                    swatch.classList.remove('swatch_selected');
                    if (optionContainer) {
                      var hiddenInput = optionContainer.querySelector('.hulk_swatch_hidden_prop');
                      if (hiddenInput) {
                        hiddenInput.value = "";
                        lastActiveHidden = null;
                      }
                    }
                    lastActiveSwatch = null;
                    return;
                  }
                  if (optionContainer) {
                    var groupSwatches = optionContainer.querySelectorAll('.hulk_po_radio');
                    groupSwatches.forEach(function(item) {
                      item.classList.remove('swatch_selected');
                    });
                    var hiddenInput = optionContainer.querySelector('.hulk_swatch_hidden_prop');
                    if (hiddenInput) {
                      hiddenInput.value = swatch.getAttribute('value');
                      lastActiveHidden = hiddenInput;
                    }
                  }
                  swatch.classList.add('swatch_selected');
                  lastActiveSwatch = swatch;
                  console.log("Swatch Debug: Active swatch set with value: " + swatch.getAttribute('value'));
                });
              });
            }
          
            if (document.readyState === "complete" || document.readyState === "interactive") {
              setTimeout(initSwatchSelector, 0);
            } else {
              document.addEventListener("DOMContentLoaded", initSwatchSelector);
            }
        }
  }, 900);
})();
